import { gsap, PhotoSwipe, PhotoSwipeLightbox } from '../LibrariesImport';
import { GlobalVariables } from '../GlobalVariables';

export default class BlockFloatingImages {
	static init() {
		this.els = document.querySelectorAll('.block-floating-images');

		if (!this.els.length) {
			return;
		}


		this.initAnimations();
		this.initLinks();
	}

	static initAnimations() {
		this.els.forEach((block) => {
			const [ imgLeft, imgCenter, imgRight ] = block.querySelectorAll('.picture-frame-image');

			gsap.set(imgLeft, 	{ x: '-100%',  opacity: 0 });
			gsap.set(imgCenter, { y: '-200px', opacity: 0 });
			gsap.set(imgRight, 	{ x: '100%',   opacity: 0 });

			const scrollTrigger = {
				trigger: block,
				start: 'top 95%',
				end: 'top 75%',
				once: true,
			};

			gsap.to(imgLeft, {
				x: 0,
				opacity: 1,
				duration: 1,
				scrollTrigger,
			});

			gsap.to(imgCenter, {
				y: 0,
				opacity: 1,
				scrollTrigger,
			});

			gsap.to(imgRight, {
				x: 0,
				opacity: 1,
				duration: 1,
				scrollTrigger,
			});
		});
	}

	static initLinks() {
		this.els.forEach((el, idx) => {
			const imagesEls = el.querySelectorAll('.picture-frame-image');

			imagesEls.forEach((image) => {
				const linkEl = image.querySelector('[data-click-behavior]');
				const { clickBehavior, cycloramaUrl } = linkEl.dataset;

				switch (clickBehavior) {
					case 'gallery': {
						const imgEl = image.querySelector('img');
						const options = {
							dataSource: [{
								src: imgEl.src,
								srcset: imgEl.getAttribute('srcset'),
								width: +imgEl.getAttribute('width'),
								height: +imgEl.getAttribute('height'),
								alt: imgEl.alt,
							}],
							initialZoomLevel: 'fit',
							maxZoomLevel: 1,
							zoom: false,
						};

						return this.initLightbox(options, linkEl);
					}
					case 'cyclorama': {
						if (!cycloramaUrl) {
							return console.info('No cyclorama URL provided', el, linkEl);
						}

						const options = {
							dataSource: [{
								html: `<iframe width="100%" height="100%" loading="eager" src="${cycloramaUrl}" allowfullscreen allowtransparency>`,
							}],
						};

						return this.initLightbox(options, linkEl);
					}
					case 'cta': {
						const formSectionEl = document.querySelector('.section:has(form)');

						if (!formSectionEl) {
							return console.info('Could not find any form section', el);
						}

						return this.setSmoothScrollTo(linkEl, formSectionEl);
					}
					default:
						console.info('invalid click behavior on block 3 floating images', el);
						break;
				}
			});
		});
	}

	/**
	 * @param options PhotoSwipeLightbox options
	 * @param trigger Element to add the event listener to
	 */
	static initLightbox(options, trigger) {
		const defaultOptions = {
			dataSource: [],
			showHideAnimationType: 'zoom',
			pswpModule: PhotoSwipe,
		};

		// combined the options objects
		const pswpLightboxOptions = {...defaultOptions, ...options};

		const lightbox = new PhotoSwipeLightbox(pswpLightboxOptions);
		lightbox.init();

		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			lightbox.loadAndOpen(0);
		});
	}


	static setSmoothScrollTo(trigger, target) {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			GlobalVariables.smoother.scrollTo(target, true);
		});
	}
}
